import './index.scss';


document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('.pd-block-callout-bar').forEach(function(element){
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        pin: false,   // pin the trigger element while active
        start: "top 80%", // when the top of the trigger hits the top of the viewport
      },
    });

    tl
      .from('.pd_callout-slice-accent', {height: 0, bottom: "50%"})
      .from('.pd_callout-content .acf-innerblocks-container', {opacity: 0}, "-=0.3")
      .from('.pd_callout-sequence-pattern', {opacity: 0})
  })

  gsap.utils.toArray(".pd_callout-image img").forEach((section, i) => {
    gsap.timeline({ 
      scrollTrigger: {
        trigger: section.parentElement,
        scrub: true,
        invalidateOnRefresh: true
      }})
      .fromTo(section, { 
      y: () => - (section.offsetHeight - section.parentElement.offsetHeight)        
    }, {
      y: 0,
      ease: "none"
    });
  });
})